"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLImageHashComponent = void 0;

const hash_1 = require("../utils/hash");

const webgl_1 = require("../utils/webgl");

const base_1 = require("./base");

class WebGLImageHashComponent extends base_1.CustomComponent {
  getValue() {
    var _a, _b, _c, _d;

    const webgl = (0, webgl_1.getWebGLContext)();
    const buff = (_a = webgl === null || webgl === void 0 ? void 0 : webgl.createBuffer) === null || _a === void 0 ? void 0 : _a.call(webgl);
    const program = (_b = webgl === null || webgl === void 0 ? void 0 : webgl.createProgram) === null || _b === void 0 ? void 0 : _b.call(webgl);
    const vertex = (_c = webgl === null || webgl === void 0 ? void 0 : webgl.createShader) === null || _c === void 0 ? void 0 : _c.call(webgl, webgl.VERTEX_SHADER);
    const fragment = (_d = webgl === null || webgl === void 0 ? void 0 : webgl.createShader) === null || _d === void 0 ? void 0 : _d.call(webgl, webgl.FRAGMENT_SHADER);

    if (!webgl || !buff || !program || !vertex || !fragment || typeof Uint8Array === 'undefined') {
      return '';
    }

    let hash = '';

    try {
      webgl.bindBuffer(webgl.ARRAY_BUFFER, buff);
      webgl.bufferData(webgl.ARRAY_BUFFER, new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.7321, 0]), webgl.STATIC_DRAW);
      const itemSize = 3;
      const numItems = 3;
      webgl.shaderSource(vertex, 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}');
      webgl.compileShader(vertex);
      webgl.shaderSource(fragment, 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}');
      webgl.compileShader(fragment);
      webgl.attachShader(program, vertex);
      webgl.attachShader(program, fragment);
      webgl.linkProgram(program);
      webgl.useProgram(program);
      const vertexPosAttrib = webgl.getAttribLocation(program, 'attrVertex');
      const offsetUniform = webgl.getUniformLocation(program, 'uniformOffset');
      webgl.enableVertexAttribArray(vertexPosAttrib);
      webgl.vertexAttribPointer(vertexPosAttrib, itemSize, webgl.FLOAT, !1, 0, 0);
      webgl.uniform2f(offsetUniform, 1, 1);
      webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, numItems);
      const arr = new Uint8Array(131072);
      webgl.readPixels(0, 0, 256, 128, webgl.RGBA, webgl.UNSIGNED_BYTE, arr);
      const str = JSON.stringify(arr).replace(/,?"[0-9]+":/g, '').replace(/^{[0]+}$/g, '');
      hash = (0, hash_1.x64Hash128)(str);
    } finally {
      return hash;
    }
  }

}

exports.WebGLImageHashComponent = WebGLImageHashComponent;